export default {"componentDescription":"","propDescriptions":{},"classDescriptions":{}};